import moment from "moment";

/**
 * Détermine le statut d'affichage d'une réservation (une ligne de commande)
 * à partir de l'état de la commande, de l'annulation éventuelle de ses items
 * et de la date du créneau. Fonction pure, sans effet de bord.
 *
 * Prend une réservation à plat telle que renvoyée par la query `myReservations`
 * (orderState / cancelled / date / schedule) : c'est désormais le backend qui
 * agrège les items d'une ligne en un booléen `cancelled`.
 *
 * Comparaison "Passée" en date seule (YYYY-MM-DD, offset-aware) conformément
 * à la règle TZ du projet.
 *
 * @returns {{ label: string, variant: string, ariaLabel: string }}
 */
export default function reservationStatus(reservation) {

    const date = reservation.date;
    const schedule = reservation.schedule;
    const offset = (schedule && schedule.utcOffset) || 0;

    let label;
    let variant;

    if (reservation.orderState === "Cancelled" || reservation.cancelled) {
        label = "Annulée";
        variant = "danger";
    } else if (reservation.orderState === "ArrangingAdditionalPayment") {
        label = "En attente de paiement";
        variant = "warning";
    } else if (date && moment(date).utcOffset(offset).format("YYYY-MM-DD") < moment().utcOffset(offset).format("YYYY-MM-DD")) {
        label = "Passée";
        variant = "secondary";
    } else {
        label = "Confirmée";
        variant = "success";
    }

    return { label, variant, ariaLabel: "Statut : " + label };
}
